import { z } from 'zod';
import { zStringRequired } from '../../z';
export const mswFollowUpValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        problem: z.string().optional().nullable(),
        mswProgress: z.string().optional().nullable(),
        followUpPlan: z.string().optional().nullable(),
        patientAssessmentComments: z.string().optional(),
        patientAssessment: z.boolean().optional(),
        communityLinkageComments: z.string().optional(),
        communityLinkage: z.boolean().optional(),
        counselingServicesComments: z.string().optional(),
        counselingServices: z.boolean().optional(),
        medicalSocialServicesComments: z.string().optional(),
        medicalSocialServices: z.boolean().optional(),
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
